<section class="vo-welcome" aria-labelledby="welcome-title">
  <div class="vo-welcome__intro">
    <span class="vo-eyebrow">Anfrage starten</span>
    <h1 class="vo-hero-title" id="welcome-title">Wie können wir Ihnen helfen?</h1>
    <p class="vo-hero-sub">Wählen Sie eine Leistung. Danach dauert es unter 3 Minuten bis zu 5 Offerten.</p>
  </div>

  <div class="vo-service-grid">
    <button *ngFor="let card of cards" type="button" class="vo-service-card" (click)="start(card.value)">
      <span class="vo-service-card__icon"><app-icon [name]="card.icon" [size]="26"/></span>
      <span class="vo-service-card__title">{{ card.title }}</span>
      <span class="vo-service-card__desc">{{ card.text }}</span>
      <span class="vo-service-card__cta">
        {{ card.cta }}
        <app-icon name="arrow-right" [size]="16"/>
      </span>
    </button>
  </div>

  <ul class="vo-trust-row">
    <li><app-icon name="circle-check" [size]="16"/> Kostenlos &amp; unverbindlich</li>
    <li><app-icon name="clock" [size]="16"/> Unter 3 Minuten</li>
    <li><app-icon name="shield-check" [size]="16"/> Verschlüsselte Übermittlung</li>
  </ul>
</section>
